import React, { useState } from "react";
import { createClient } from "@supabase/supabase-js";
import HeroBanner from "./LandingPage/HeroBanner";

const REACT_APP_SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const REACT_APP_SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

const supabase = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY);

const Reg = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) {
            setMessage(error.message);
        } else {
            setMessage("Registration successful! Check your email for confirmation.");
        }
        // navigate to the home page after registration
        window.location.href = "/";
    };

    return (
        <>
            <HeroBanner />
        <div style={{
            width: 350,
            margin: "60px auto",
            padding: 24,
            borderRadius: 12,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            background: "#fff",
            fontFamily: "sans-serif"
        }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>Register</h2>
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    required
                    onChange={e => setEmail(e.target.value)}
                    style={{
                        padding: "10px 12px",
                        borderRadius: 6,
                        border: "1px solid #ddd",
                        fontSize: 16
                    }}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={e => setPassword(e.target.value)}
                    style={{
                        padding: "10px 12px",
                        borderRadius: 6,
                        border: "1px solid #ddd",
                        fontSize: 16
                    }}
                />
                <button
                    type="submit"
                    style={{
                        padding: "10px 0",
                        borderRadius: 6,
                        border: "none",
                        background: "#79A27D",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: 16,
                        cursor: "pointer"
                    }}
                >
                    Register
                </button>
            </form>
            {message && (
                <div style={{ marginTop: 18, color: "#0074D9", textAlign: "center" }}>
                    {message}
                </div>
            )}
        </div>
        </>

    );
};

export default Reg;